'use client';

import { useState } from 'react';
import TransformationCard from './TransformationCard';
import TransformationModal from './TransformationModal';

const transformations = [
  {
    id: 1,
    name: 'Rayyan Hamza',
    title: 'Precision Results through EMS Technology',
    desc: 'Experience the power of specialized EMS sessions. Rayyan Hamza utilized our state-of-the-art Electro Muscle Stimulation system to accelerate his fitness journey. By combining high-frequency training with professional dietary guidance, he reached his peak physical condition in record time.',
    images: [
      '/Transformations/Rayyan/before.webp',
      '/Transformations/Rayyan/after.webp',
    ],
  },
  {
    id: 2,
    name: 'Lubna Khan',
    title: 'Precision Wellness & Toning',
    desc: 'By leveraging the efficiency of EMS technology, Lubna Khan reached her fitness milestones with precision. Her 8-week challenge focused on total body toning and sustainable weight management, resulting in a remarkable physical recomposition tailored to her personal wellness goals.',
    images: [
      '/Transformations/Lubna Khan/before.webp',
      '/Transformations/Lubna Khan/after.webp',
      
    ],
  },
  {
    id: 3,
    name: 'Mr Jamil Ahmed',
    title: '12-Week Postural Alignment Program',
    desc: 'Jamil Ahmed reclaimed his physical vitality through a dedicated 12-week Pilates Reformer program. By focusing on core stability and spinal decompression, he successfully corrected years of postural strain, achieving a leaner, more aligned, and energized physique at Aura Wellness Clubs.',
    images: [
      '/Transformations/jamil/before.webp',
      '/Transformations/jamil/after.webp',
      
    ],
  },
];

export default function TransformationGrid() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      {/* Responsive Grid Layout:
        - Mobile: 1 column (grid-cols-1) with smaller gap (gap-6)
        - Tablet: 2 columns (sm:grid-cols-2) with medium gap (md:gap-8)
        - Desktop: 3 columns (lg:grid-cols-3) with larger gap (lg:gap-10) to fit all 3 items in one row
      */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10 w-full">
        {transformations.map((t) => (
          <TransformationCard
            key={t.id}
            data={t}
            onClick={() => setSelected(t)}
          />
        ))}
      </div>

      {selected && (
        <TransformationModal
          data={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </>
  );
}